/* Contains the default layouts structure for each page */

import { v4 as uuid4 } from "uuid"
import { ALL_COMPONENTS, getNextComponentId } from "@/store/constants/all_components"
import { utils } from "@/store/helpers"

const getPageDefaultLayout = (object_type) => {
  const objectTypeData = utils.getObjectTypeByType(object_type)
  const slug = utils.slugify(object_type, "-")
  const pluralLabel = objectTypeData?.plural_label || utils.nounHelper.toPlural(objectTypeData?.label || object_type)

  // Define the main object records page layout
  const layout = [
    {
      h: 48,
      w: 72,
      x: 0,
      y: 0,
      minW: 24,
      minH: 24,
      is_static: true,
      fixed: true,
      id: uuid4(),
      moved: false,
      props: {
        component_type: ALL_COMPONENTS.OBJECT_TABLE,
        component_reference: getNextComponentId(ALL_COMPONENTS.OBJECT_TABLE, []),
        component_props: {
          label: `${pluralLabel} ` + window.$t("Table"),
          objectType: object_type
        }
      }
    }
  ]

  return [layout, pluralLabel, slug]
}

export default getPageDefaultLayout
